import type { Booking } from "@/types/camping";

export interface PlaceBanNoticeProps {
  booking: Booking;
  className?: string;
}

export function PlaceBanBadge({ prominent = false }: { prominent?: boolean }) {
  return (
    <span
      className={
        prominent
          ? "inline-flex items-center gap-1 rounded-md border border-status-red/60 bg-status-red px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white shadow-sm"
          : "inline-flex items-center gap-1 rounded-md border border-status-red/40 bg-status-red/20 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-status-red"
      }
    >
      {prominent ? "⚠ " : null}
      Platzverbot
    </span>
  );
}

export function PlaceBanNotice({ booking, className }: PlaceBanNoticeProps) {
  if (!booking.place_ban_flagged) return null;

  const matched = booking.place_ban_matched_guest_name;
  const reason = booking.place_ban_reason;

  return (
    <div
      className={
        className ??
        "rounded-xl border-2 border-status-red/50 bg-status-red/12 px-4 py-4 text-sm text-label shadow-sm"
      }
      role="alert"
    >
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-base font-bold text-status-red">Platzverbot – manuelle Prüfung erforderlich</p>
        <PlaceBanBadge prominent />
      </div>
      <p className="mt-2 text-label-secondary">
        Diese Buchung wurde als Anfrage angelegt, weil ein Platzverbot erkannt wurde. Der Gast sieht
        davon nichts.
      </p>
      {matched ? (
        <p className="mt-2">
          <span className="text-label-tertiary">Abgleich mit: </span>
          <span className="font-medium">{matched}</span>
        </p>
      ) : null}
      {reason ? (
        <p className="mt-1">
          <span className="text-label-tertiary">Begründung: </span>
          {reason}
        </p>
      ) : null}
      <p className="mt-2 text-xs text-label-tertiary">
        Bei Zufallstreffern können Sie die Anfrage trotzdem bestätigen und den Gast aufnehmen.
      </p>
    </div>
  );
}
